export const LIMIT = 20;
export const passwordRegex = /^(?=.*[a-z].*[a-z])(?=.*[\W].*[\W])(?=.*[A-Z].*[A-Z])(?=.*[\d].*[\d])[^\s]{12,}$/;
export const phoneRegex = /^[0-9]+$/;
export const emailRegex =
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
